import { shadowPalette } from "@/styles/themes/colors/palettes";

export const aliasShadow = {
  main: shadowPalette["1dp"],
} as const;

export type AliasShadowScheme = "shadow";

export type AliasShadow = `${AliasShadowScheme}.${keyof typeof aliasShadow}`;
